import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2
      }}
    >
      <Stack spacing={1.5} alignItems="center" sx={{ textAlign: 'center', maxWidth: 520 }}>
        <Typography variant="h3">404</Typography>
        <Typography variant="h5">Page not found</Typography>
        <Typography variant="body2" sx={{ opacity: 0.75 }}>
          Halaman yang kamu cari tidak tersedia atau kamu tidak punya akses.
        </Typography>
      </Stack>
    </Box>
  );
}
